import React from 'react';
import ReactDOM from 'react-dom';
import HBox from '../../../layout/container/h_box/HBox';
import CellActions from '../../cell_renderer/CellActions';
import CellButton from '../../cell_renderer/CellButton';
import CellCheckbox from '../../cell_renderer/CellCheckbox';
import CellIcon from '../../cell_renderer/CellIcon';
import CellProgress from '../../cell_renderer/CellProgress';
import CellTag from '../../cell_renderer/CellTag';
import { isEqual, isUndefined } from 'lodash';
import CellCount from '../../cell_renderer/CellCount';
import CellLink from '../../cell_renderer/CellLink';
import CellRouteLink from '../../cell_renderer/CellRouteLink';
import CellDate from '../../cell_renderer/CellDate';
import CellText from '../../cell_renderer/CellText';
import CellTextCounterTag from '../../cell_renderer/CellTextCounterTag';
import { isElNotLinkButtonOrInput } from '../../../../utility';
import { LIST_ITEM_PROPS } from './Types';
import {
  CELL_CONFIG_ABSTRACT
} from '../../../grid/cell_renderer/Types';

class ListItem extends React.Component<LIST_ITEM_PROPS, {}> {
  private CELL_RENDER_MAP = {
    actions: CellActions,
    button: CellButton,
    checkbox: CellCheckbox,
    count: CellCount,
    date: CellDate,
    icon: CellIcon,
    link: CellLink,
    routeLink: CellRouteLink,
    progress: CellProgress,
    tag: CellTag,
    text: CellText,
    textCounterTag: CellTextCounterTag
  };
  cellNodes = new Map();

  shouldComponentUpdate(nextProps: Readonly<LIST_ITEM_PROPS>, nextState: Readonly<{}>, nextContext: any): boolean {
    return !isEqual(this.props, nextProps);
  }

  private cellRender = (dataItem: any, { expanded = true, preventSubitemRender, ...column }: any) => {
    if (preventSubitemRender) {
      return null;
    }

    let returnValue = null;

    if (expanded) {
      expanded = (expanded === true) ? {
        ...column
      } : {
        ...column,
        ...expanded
      };

      const { cellType, dataIndex, field } = expanded;
      const cellRender = isUndefined(cellType) ? (field || dataIndex).split('.').shift() : cellType;
      const Tag = this.CELL_RENDER_MAP.hasOwnProperty(cellRender) ? this.CELL_RENDER_MAP[cellRender] : this.CELL_RENDER_MAP.text;

      if (Tag) {
        const props = {
          ...expanded,
          ...this.getAdditionalProps(cellRender),
          dataItem,
          htmlTag: 'div'
        };

        returnValue = <Tag {...props} />;
      }
    }

    return returnValue;
  };

  private getAdditionalProps = (cellRender: string) => {
    const additionalProps: any = {};

    if (cellRender === 'checkbox') {
      additionalProps.updateRecord = this.props.onChangeItem;
    }

    return additionalProps;
  };

  private onContextMenu = (event) => {
    if (this.props.onContextMenu) {
      this.props.onContextMenu(event, this.props.dataItem);
    }
  }

  /**
   * Trigger on double click and call onDetailDoubleClick method
   * onDetailDoubleClick is defined in the grid config
   * @param {React.MouseEvent} event
   * @private
   */
  private handleDoubleClick(event) {
    const { tagName } = event.target;
    const { dataItem, onDetailItemDoubleClick } = this.props;

    // If the double click is not on the button, input, or link then call onDetailDoubleClick
    if (onDetailItemDoubleClick && isElNotLinkButtonOrInput(tagName)) {
      onDetailItemDoubleClick(dataItem);
    }
  }

  renderCellItem = (dataItem, uniqueField, dataIndex, align, column, rowHeight) => (
    <HBox
      alignItemsCenter
      className="tp-sub-lvl-cell"
      key={`${dataItem[uniqueField]}-${dataIndex}`}
      justifyContentCenter={align === 'center'}
      justifyContentEnd={align === 'right'}
      justifyContentStart={align === 'left'}
      style={{ height: rowHeight, minWidth: column.width }}
      ref={(cell) => {
        if (cell) {
          this.cellNodes.set(dataIndex, ReactDOM.findDOMNode(cell));
        } else {
          this.cellNodes.delete(dataIndex);
        }
      }}
    >
      {this.cellRender(dataItem, column)}
    </HBox>
  )

  render() {
    const { columns, dataItem, rowHeight, uniqueField, onClick, onKeyDown, onKeyUp, parentDataIndex } = this.props;
    const { index } = dataItem;

    const cellsContent = [];

    columns.filter(column => !column.hidden).forEach((column, colIndex) => {
      const {
        cellConfig = {},
        dataIndex
      } = column;
      const { align = 'left' } = cellConfig as CELL_CONFIG_ABSTRACT;

      if (column.isGrouped) {
        column.subColumns.filter(subCol => !subCol.hidden).forEach((subColumn, subIndex) => {
          cellsContent.push(this.renderCellItem(dataItem, uniqueField, subColumn.dataIndex, align, subColumn, rowHeight));
        });
      } else {
        cellsContent.push(this.renderCellItem(dataItem, uniqueField, dataIndex, align, column, rowHeight));
      }
    });

    return (
      <HBox
        dataCy={`tr-sub-${parentDataIndex}-${index}`}
        role={'row'}
        alignItemsCenter
        className="tp-sub-lvl-row"
        onContextMenu={this.onContextMenu}
        onClick={onClick}
        onDoubleClick={(event: React.MouseEvent) => this.handleDoubleClick(event)}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        tabIndex={0}
        id={`ID_${dataItem[uniqueField]}`}
      >{cellsContent}
      </HBox>
    );
  }
}

export default ListItem;
